var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error-alert"}},[(_vm.showAlert)?_c('div',{staticClass:"pap-form__error-alert"},[_vm._v(_vm._s(_vm.msg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }